// extracted by mini-css-extract-plugin
module.exports = {"textarea":"style_textarea__sn9cC"};